"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CustomerInterface_1 = require("../../../BusinessLogicLayer/CustomerInterface");
const exception_1 = require("@almservices-cl/exception");
class CustomerNotifications {
    constructor(customerRepository) {
        this.getCustomerNotifications = async (_token, customerId) => {
            const customers = await this.customerRepository.getCustomers();
            const customer = customers.find(({ id }) => id === customerId);
            if (customer === undefined) {
                throw new exception_1.RuntimeException(`Customer of id ${customerId} was not found`);
            }
            return customer.notifications;
        };
        this.clearCustomerNotifications = async (customerId) => {
            const customers = await this.customerRepository.getCustomers();
            const customer = customers.find(({ id }) => id === customerId);
            if (customer === undefined) {
                throw new exception_1.RuntimeException("User was not found");
            }
            customer.notifications = {
                hasUnseenMeal: false,
                hasUnreadMessage: false,
                hasUnseenTraining: false,
                hasUnseenRecovery: false,
                hasUnseenBehaviour: false,
                hasUnseenMeasurement: false,
                hasUnseenLife: false,
                hasUnseenMind: false,
            };
            customer.responseDeadLine = null;
            return this.customerRepository.updateCustomers(customers);
        };
        this.getCustomerActions = (_customerId) => {
            return Promise.resolve([
                {
                    id: "1",
                    dismissable: false,
                    type: CustomerInterface_1.CustomerActionType.PLAN_REQUIRES_CALORIE_BUDGET_ADJUSTMENT,
                    planName: "test plan 123",
                },
                {
                    id: "2",
                    dismissable: true,
                    type: CustomerInterface_1.CustomerActionType.PLAN_REQUIRES_CALORIE_BUDGET_ADJUSTMENT,
                    planName: "test plan 123",
                },
            ]);
        };
        this.dismissCustomerAction = (_actionId) => {
            return Promise.resolve();
        };
        this.customerRepository = customerRepository;
    }
}
exports.default = CustomerNotifications;
//# sourceMappingURL=CustomerNotifications.js.map